import { logService } from '../services'

const state = {
  dataSimplified: [],
  dataDetailed: []
}

const getters = {
  findSimplified (state) {
    return state.dataSimplified
  },
  findDetailed (state) {
    return state.dataDetailed
  }
}

const mutations = {
  findSimplified (state, dataSimplified) {
    state.dataSimplified = dataSimplified
  },
  findDetailed (state, dataDetailed) {
    state.dataDetailed = dataDetailed.map(data => {
      const type = data.objectClass.split('\\')

      return {
        ...data,
        objectClass: type[type.length - 1] === 'Event' ? 'Evénement' : type[type.length - 1]
      }
    })
  }
}

const actions = {
  findSimplified (context, { datetimeFrom, datetimeTo }) {
    return logService.findSimplified(datetimeFrom, datetimeTo)
      .then(response => {
        context.commit('findSimplified', response.data)
        return response
      })
  },
  findDetailed (context, { datetimeFrom, datetimeTo }) {
    return logService.findDetailed(datetimeFrom, datetimeTo)
      .then(response => {
        context.commit('findDetailed', response.data)
        return response
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
